<pos-totals [totals]="orderSimulate.totals"></pos-totals>
<div class="row">

    <div class="col-12 col-sm-12 col-md-12">
        <pos-table tableFormId="productsCartTable" [data]="productsCart" [headers]="getProductCartHeaders()"
            [filters]="[]" [itemsPerPage]="10" [pagination]="false" (dataSave)="saveProductCart($event)"
            (getTableForm)="getTableForm($event)" [disableHighlight]="true">

        </pos-table>

    </div>
</div>